import { memo, type MouseEvent } from "react";
import type { InventoryItem, SlotLocation, ContainerCapacity } from "../types";
import { SectionLabel } from "./SectionLabel";
import { InventoryGrid } from "./InventoryGrid";
import carIcon from "../assets/images/car-icon.webp";

interface Props {
  items: (InventoryItem | null)[];
  carPlate: string;
  capacity: ContainerCapacity;
  selectedLocation?: SlotLocation | null;
  onItemClick: (item: InventoryItem, location?: SlotLocation) => void;
  onItemRightClick: (
    e: MouseEvent,
    item: InventoryItem,
    location?: SlotLocation,
  ) => void;
}

export const CarTrunk = memo(function CarTrunk({
  items,
  carPlate,
  capacity,
  selectedLocation,
  onItemClick,
  onItemRightClick,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      <SectionLabel
        icon={carIcon}
        title="Car Trunk"
        //  subtitle="here you keeping your stuff"
        extra={
          <span className="text-xs font-bold uppercase text-white">
            {carPlate}
          </span>
        }
      />
      <InventoryGrid
        items={items}
        section="carTrunk"
        capacity={capacity}
        selectedLocation={selectedLocation}
        onItemClick={onItemClick}
        onItemRightClick={onItemRightClick}
      />
    </div>
  );
});
